// @flow

import type {$AxiosXHR} from 'axios';
import type {Projects} from '../../reducers/projects/types.js';

import axios from 'axios';
import {MerchantNotSetError, normalizeMerchantId} from '../../utils/merchant';

type getProjectsParams = {
  merchantId: number,
  sort?: string | null
};

export const getProjects = (params: getProjectsParams): Promise<Projects> => {
  const merchantId = normalizeMerchantId(params.merchantId);
  if (merchantId === null) {
    return Promise.reject(new MerchantNotSetError());
  }

  return axios
    .get(`/merchant/current/merchants/${merchantId}/projects`, {params: {sort: params.sort}})
    .then((response: $AxiosXHR<Projects>) => response.data);
};
